// extracted by mini-css-extract-plugin
export var messageSideLeft = "_gb-1";
export var messageSideRight = "_gb-2";
export var orderLookupBubbleContainer = "_gb-0";
export var submitButton = "_gb-3";